import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ShowIfAllowed from '../../../components/common/show-if-allowed';
// import ExcelButton from '../../../components/common/table/excel-button/excel-button';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import Title from '../../../components/common/title';
import { CROP_FIELD_HISTORY } from '../../../router/routes';
import FieldHistoryTable from './history';
import FieldHistoryOverview from './overview';

export enum TabKey {
  HISTORY = 'history',
  OVERVIEW = 'overview',
}

export default function FieldHistoryIndex() {
  const { t } = useTranslation();
  const transKeyPrefix = 'pages.crop.field-history.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  const [tab, setTab] = useTab(CROP_FIELD_HISTORY, ['tab', 'farmId', 'season']);

  return (
    <>
      <Title title={tp('title')} />
      <TabContainer
        selectedTabKey={tab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <ShowIfAllowed ability={{ entity_type: 'field' }}>
              <TabLink tabKey={TabKey.HISTORY}>{tp('section.history')}</TabLink>
              <TabLink tabKey={TabKey.OVERVIEW}>
                {tp('section.overview')}
              </TabLink>
            </ShowIfAllowed>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <ShowIfAllowed ability={{ entity_type: 'field' }}>
              <Tab tabKey={TabKey.HISTORY}>
                <FieldHistoryTable />
              </Tab>
              <Tab tabKey={TabKey.OVERVIEW}>
                <FieldHistoryOverview />
              </Tab>
            </ShowIfAllowed>
          </TabContents>
        }
      />
    </>
  );
}
